(function(){const MZ=window.MZ;if(!MZ||!MZ.mount||MZ.__mdemo)return;MZ.__mdemo=1;
/* Every one of the 29 mechanisms gets the drawing that actually shows ITS mechanism. */
const MAP={
M001:['rotor'],M002:['wind'],M003:['spring'],M004:['hairspring'],M005:['escapement'],
M006:['coaxial'],M007:['chrono'],M008:['chrono_seq',{mode:'mono'}],M009:['chrono_seq',{mode:'fly'}],
M010:['chrono_seq',{mode:'split'}],M011:['date'],M012:['bigdate'],M013:['cal'],M014:['cal'],
M015:['gmt'],M016:['alarm'],M017:['tourbillon'],M018:['cforce'],M019:['jump'],M020:['quartz'],
M021:['water'],M022:['timing_test'],M023:['gmt'],M024:['moon'],M025:['repeater'],M026:['daydate'],
M027:['tuningfork'],M028:['sdrive'],M029:['solar']};
const ICO='<svg viewBox="0 0 24 24" width="25" height="25" fill="none" stroke="#A04933" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1"/></svg>';
function curId(el){try{
  const root=(el&&el.closest&&el.closest('#mz-modal'))||document.getElementById('mz-modal')||document;
  const a=root.querySelector('article.mz-reading');
  return (a&&a.dataset.entry)||(location.hash||'').slice(1);
}catch(e){return ''}}
const o=MZ.mount;
MZ.mount=function(name,el,opts){
 try{if(el&&el.id==='mz-md'){const m=MAP[curId(el)];if(m&&MZ.demos[m[0]]){name=m[0];opts=m[1]||{}}}}catch(e){}
 return o.call(MZ,name,el,opts)};
/* cforce readout wrapping fix */
const cf=MZ.demos.cforce;
if(cf)MZ.demos.cforce=function(el,oo){const r=cf.apply(this,arguments);try{const t=[].slice.call(el.querySelectorAll('text')).filter(function(x){return x.getAttribute('x')==='335'&&x.getAttribute('y')==='200'})[0];if(t){const ns='http://www.w3.org/2000/svg';const fix=function(){if(t.children.length)return;const p=t.textContent.split(' · ');t.setAttribute('font-size','13');t.setAttribute('y','196');t.textContent='';p.forEach(function(q,i){const sp=document.createElementNS(ns,'tspan');sp.setAttribute('x','335');sp.setAttribute('dy',i?'18':'0');sp.textContent=q;t.appendChild(sp)})};fix();new MutationObserver(fix).observe(t,{childList:true})}}catch(e){}return r};
/* Label the drawing, and create one where the app left the slot out. */
function head(){const h=document.createElement('div');h.className='mz-bsec';
 h.innerHTML=ICO+'<span>'+(MZ.lang==='ar'?'جرّب الآلية بنفسك':'Try the mechanism')+'</span>';return h}
function inject(){try{
 const root=document.getElementById('mz-modal');if(!root)return;
 const ar=root.querySelector('article.mz-reading');if(!ar)return;
 const id=ar.dataset.entry;const m=MAP[id];if(!m||!MZ.demos[m[0]])return;
 /* the drawing belongs right after the opening passage, not under the source list */
 const anchor=ar.querySelector('.mz-reading-lead')||ar.querySelector(':scope > p')
   ||ar.querySelector('.mz-reading-toc')||ar.querySelector('.mz-reading-meta');
 if(!anchor)return;
 let md=root.querySelector('#mz-md');
 if(md){
  const host=md.closest('.mz-demo-reading')||md;
  if(host.classList.contains('mz-mechdemo'))return;
  host.classList.add('mz-mechdemo');
  const w=document.createElement('section');w.className='mz-mechwrap';w.id='mz-mech';
  anchor.insertAdjacentElement('afterend',w);
  /* the app may already title the block - don't stack two headings */
  if(!host.querySelector('h2,h3,h4'))w.appendChild(head());
  w.appendChild(host);
  return}
 if(ar.dataset.mech===id)return;ar.dataset.mech=id;
 const w=document.createElement('section');w.className='mz-mechwrap';w.id='mz-mech';
 md=document.createElement('div');md.className='mz-dark mz-mechdemo';md.id='mz-md';
 w.appendChild(head());w.appendChild(md);
 anchor.insertAdjacentElement('afterend',w);
 MZ.mount(m[0],md,m[1]||{});
}catch(e){}}
let t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(inject,150)}).observe(document.documentElement,{childList:true,subtree:true});
setInterval(inject,600);
})();
(function(){var b=window.MZ_IMAGE_BASE||'';if(b.indexOf('mz-img-H001.webp')<0||document.getElementById('mz-h-theme'))return;var t=document.createElement('script');t.src=b.replace('mz-img-H001.webp','mz-h-theme.js');document.head.appendChild(t)})();
